module.exports = __webpack_public_path__ + "media/images/lp_v6_21-4d6417550ea71989f3fac07cce2774dc.webp";